import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CustomerDivisionsComponent} from './customer-divisions.component';
const routes: Routes = [
  {
    path: '',
    component: CustomerDivisionsComponent
  }
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CustomerDivisionsRoutingModule { }
